export default {
  selectedStatus(state) {
    return state.selectedStatus;
  },
  searchText(state) {
    return state.searchText;
  },
  stringFilter(state) {
    let filter = '';
    if (state.searchText) {
      const val = state.searchText.replaceAll('"', '\\"').replaceAll('\'', '\\\'').toLowerCase();
      filter += `(titulo like '%${val}%') or (configuracaoVenda.nome like '%${val}%') or (categoria.descricao like '%${val}%') or (codigoInterno like '%${val}%')`;
    }
    return filter;
  },
};
